import { render, staticRenderFns } from "./RolesAndRights.vue?vue&type=template&id=99e0fc32&scoped=true&"
import script from "./RolesAndRights.vue?vue&type=script&lang=js&"
export * from "./RolesAndRights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e0fc32",
  null
  
)

export default component.exports